export default {
  addOns: 'Extensions',
  availability: 'Disponibilité',
  availabilityDaySelector: 'Sélecteur de date de disponibilité',
  unavailable: 'Indisponible',
  person: 'personne',
  people: 'personnes',
  reserveNow: 'Réserver maintenant',
  selectTime: "Sélectionner l'heure",
  select: 'Sélectionner',
  reserve: 'Réserver',
  time: 'Heure',
  tier: 'Niveau',
  questions: 'Questions',
  addToCart: 'Ajouter au panier',
  checkout: 'Paiement',
  total: 'Total',
  whatsIncluded: 'Ce qui est inclus',
  showMore: 'Voir plus',
  showLess: 'Voir moins',
  session: 'Session',
  viewDetails: 'Voir les détails',
  findAvailability: 'Trouver la disponibilité',
  loading: 'Chargement',
  capacity: 'Capacité',
  noAvailableSessionsOnThisDate: 'Aucune session disponible à cette date',
  noGroupAvailableOnThisDateAndTime:
    'Aucun(e) {{groupTitle}} disponible à cette date et heure',
  noCollectionFound: 'Aucune collection trouvée!',
  noResourceGroupFound: 'Aucun groupe de ressources trouvé!',
  noData: 'Pas de données!',
  continue: 'Continuer',
  night: 'nuit',
  nights: 'nuits',
  noAvailableSessionsForSelectedDates:
    "Certaines dates de votre sélection n'ont pas de sessions disponibles. Veuillez sélectionner des dates différentes.",
  from: 'à partir de',
  dateRangeSelector: 'Sélecteur de plage de dates',
  priceTierRadioGroup: 'Sélecteur de niveau de prix',
  startTime: 'Heure de début',
  duration: 'Durée',
  lengthOfStay: 'Durée du séjour',
  startDate: 'Date de début',
  endDate: 'Date de fin',
  selectDates: 'Sélectionner les dates',
  more: 'Plus',
  selectStartTime: 'Choisir une heure de début',
  endTime: 'Heure de fin',
  selectEndTime: 'Choisir une heure de fin',
  morning: 'Matin',
  afternoon: 'Après-midi',
  save: 'Enregistrer',
  selectDuration: 'Choisir une durée',
  forLength: 'pour {{length}}',
  moreDates: '{{count}} de plus',
  addDate: 'Ajouter une date',
  start: 'Début',
  end: 'Fin',
  pickupFrom: 'Retrait à partir de',
  returnBy: 'Retour avant',
  day: 'jour',
  days: 'jours',
  hour: 'heure',
  hours: 'heures',
};
